import { MdOutlineStar } from 'react-icons/md';
import React from 'react';
import { useState } from 'react';
import AccordionSection from './AccordionSection';
import './AccordionSection.scss';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../init.firebase';
import { useNavigate } from 'react-router-dom';
import { useAddToCartNewDataByEmailMutation } from '../../redux/addToCart/addToCartApi';
import { toast } from 'react-toastify';

const reviewTotal = (review) => {
	switch (review) {
		case 0:
			return 'No reviews';
		case 1:
			return 'One review';

		default:
			return `${review} reviews`;
	}
};

const RightSidebar = ({ setShow, singleProductData }) => {
	const [user] = useAuthState(auth);
	const navigate = useNavigate();
	const { name, reviews, price, tags } = singleProductData || {};
	const [mlColor, setMlColor] = useState(false);

	const [addToCartNewDataByEmail, { isLoading, isError, isSuccess }] =
		useAddToCartNewDataByEmailMutation();

	const addToCartProduct = (product) => {
		if (user) {
			const data = {
				product: singleProductData._id,
			};
			const userEmail = user.email;

			addToCartNewDataByEmail({ userEmail, data });
		} else {
			navigate('/account/login');
		}
		setShow(true);
	};
	{
		isError && toast.error('Product could not be added to cart');
	}

	return (
		<>
			<div className="prod-text-sec">
				<h2>{name}</h2>

				<div
					className="prod-rating-dvi"
					style={{
						display: 'flex',
						columnDirection: 'row',
						alignItem: 'center',
						marginBottom: '10px',
					}}
				>
					<div style={{ fontSize: '1.25rem' }}>
						<MdOutlineStar />
						<MdOutlineStar />
						<MdOutlineStar />
						<MdOutlineStar />
						<MdOutlineStar />
						<span style={{ fontSize: '0.75rem' }}>
							({reviewTotal(reviews ? reviews.length : 0)})
						</span>
					</div>
				</div>
				<div
					style={{
						border: '0',
						borderColor: '#ccc',
						borderBottomWidth: '1px',
						borderBottomStyle: 'dotted',
					}}
				></div>
				<div style={{ marginTop: '0.625rem' }} className="prod-price">
					<p style={{ fontSize: '1rem' }}>
						৳ {singleProductData?.price} - {singleProductData?.weight}{' '}
						{/* <span style={{ fontSize: '0.875rem' }}>
							(৳ {singleProductData?.price})
						</span> */}
					</p>
				</div>

				{/* <div
					className="prod-div-cont"
					style={{
						display: 'flex',
						flexDirection: 'row',
						marginTop: '0.625rem',
						marginRight: '10px',
						fontSize: '0.7875rem',
					}}
				>
					<p
						onClick={() => setMlColor(true)}
						style={{
							fontWeight: 'bolder',
							border: `1px solid ${mlColor ? 'black' : '#ccc'}`,
							borderRadius: '0.3125rem',
							padding: '7px',
							marginRight: '10px',
						}}
					>
						30 ml
					</p>
				</div> */}

				<button
					onClick={() => addToCartProduct(singleProductData)}
					className={'py-2 mt-3 shadow-none cartButton'}
				>
					<span
						style={{
							animationDuration: '.5s',
							width: '100%',
							fontSize: '20px',
						}}
					>
						{!isLoading
							? ` Add to Bag - ৳${singleProductData?.price}`
							: 'Adding to Bag ...'}
					</span>
				</button>

				<div
					style={{
						display: 'flex',
						flexWrap: 'wrap',
						gap: '4px',
						marginTop: '1.5rem',
						marginBottom: '1rem',
					}}
				>
					{tags
						? tags?.map((tag, _idx) => (
								<span
									key={_idx}
									style={{
										backgroundColor: '#F5F5F5',
										padding: '2px 6px',
										fontSize: '0.85rem',
									}}
								>
									{tag}
								</span>
						  ))
						: ''}
				</div>
				{singleProductData?.description && (
					<div
						dangerouslySetInnerHTML={{ __html: singleProductData?.description }}
					></div>
				)}
				{/* <div>
          <h4
            style={{
              fontWeight: "bold",
              marginTop: "16px",
              textAlign: "center",
            }}
          >
            Frequently Bought Together
          </h4>
        </div>
        <div className="d-flex justify-content-center">
          <div className="d-flex justify-content-center align-items-center">
            <img
              src={initialImage}
              alt=""
              style={{ width: "6.25rem", height: "6.25rem" }}
            />
            <span role="button" cursor="pointer" className="fs-4 px-1 ">
              +
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <img
              src={initialImage}
              alt=""
              style={{ width: "6.25rem", height: "6.25rem" }}
            />
            <span role="button" cursor="pointer" className="fs-4 px-1">
              +
            </span>
          </div>
          <img
            src={initialImage}
            alt=""
            style={{ width: "6.25rem", height: "6.25rem" }}
          />
        </div>
        <div>
          <p className="text-center mt-5 mb-2">
            <span style={{ fontWeight: "bold" }}>Total Price:</span>{" "}
            <span style={{ color: "red" }}>৳ 250</span>
            <strike style={{ color: "#aaa", marginLeft: "0.375rem" }}>
              ৳300
            </strike>
          </p>
        </div> */}
				{/* 
        <Button
          onClick={() => setShow(true)}
          className={"py-2 shadow-none"}
          variant="dark"
          style={{
            width: "100%",
            border: "none",
            backgroundColor: "#000000",
            fontSize: "1.125rem",
          }}
        >
          Add to Bag
        </Button> */}

				<AccordionSection product={singleProductData} />
			</div>
		</>
	);
};

export default RightSidebar;
